import React, { useEffect } from 'react';
import '../cs/temp.css';
import '../cs/te.css';
import AOS from "aos";
import 'aos/dist/aos.css';

function DigitalMarketing() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true })
  }, [])
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container">
            <div className="inner-banner-content">
              <h1 className="inner-title" data-aos="fade-up">Digital Marketing</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section iot-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Stand Out Online, Get Ahead of Competition</h2>
              <p className="intro-text">
                At Codenix Infotech, we deliver end-to-end digital marketing solutions to help your business shine online and dominate your industry. From SEO and PPC to social media, content, and email marketing, our data-driven strategies ensure maximum visibility, engagement, and ROI.
              </p>
            </div>

          </div>
          <div className="intro-image iot-graphic">

          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section iot-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Digital Marketing Services</h2>
            <p className="section-description">
              Comprehensive digital marketing solutions to boost your online presence and drive business growth
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-search"></i>
              </div>
              <h3>Search Engine Optimization</h3>
              <p>Optimize your website to rank higher in search results, drive organic traffic, and capture qualified leads.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-ad"></i>
              </div>
              <h3>Pay-Per-Click Advertising</h3>
              <p>Run high-converting, targeted campaigns to attract customers and maximize ROI.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-share-alt"></i>
              </div>
              <h3>Social Media Marketing</h3>
              <p>Build your brand and engage audiences with strategic campaigns across major platforms.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <h3>Email & Content Marketing</h3>
              <p>Deliver personalized emails and high-quality content to nurture leads and increase retention.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Analytics & Reporting</h3>
              <p>Gain actionable insights through in-depth performance tracking and campaign analytics.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-bullhorn"></i>
              </div>
              <h3>Brand Development</h3>
              <p>Establish a strong, memorable brand identity that resonates with your target audience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SEO Spotlight Section */}
      <section className="intro-section">
        <div className="container">
          <div className="section-header">
            <h2>Search Engine Optimization (SEO)</h2>
            <p className="section-description">
              Our expert SEO services help your website rank higher in search engines, driving more organic traffic and qualified leads to your business.
            </p>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="seo-spotlight">
                <h3>Ranking Higher, Reaching Further</h3>
                <p>Our SEO experts conduct comprehensive website audits, perform keyword research, optimize on-page elements, build high-quality links, and create engaging content. We stay updated with the latest algorithm changes and use tools like Ahrefs, SEMrush, Google Analytics, and Moz to ensure your website aligns with best practices and achieves long-term success.</p>

                <ul className="seo-features">
                  <li><strong>Website Audit:</strong> Identify strengths and weaknesses in your current SEO performance.</li>
                  <li><strong>Keyword Research:</strong> Target the right keywords to attract your ideal audience.</li>
                  <li><strong>On-Page Optimization:</strong> Enhance meta tags, headers, and content for better rankings.</li>
                  <li><strong>Link Building:</strong> Build authoritative backlinks to boost your site's credibility.</li>
                  <li><strong>Content Creation:</strong> Develop SEO-friendly content that engages and converts.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Development Process Section */}
      <section className="design-process-section iot-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Digital Marketing Process</h2>
            <p className="section-description">
              A strategic approach to delivering impactful digital marketing solutions for your business
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Strategy Development",
                text: "We align your campaigns with your business goals and audience needs.                "
              },
              {
                num: 2,
                title: "Market Research",
                text: "We analyze competitors, trends, and customer behavior to inform strategies.                "
              },
              {
                num: 3,
                title: "Campaign Execution",
                text: "We launch SEO, PPC, social, email, and content campaigns for maximum reach"
              },
              {
                num: 4,
                title: "Performance Tracking",
                text: "We monitor campaigns with advanced analytics tools for optimization"
              },
              {
                num: 5,
                title: "Reporting & Insights",
                text: "We provide detailed reports to measure success and refine tactics "
              },
              {
                num: 6,
                title: "Continuous Optimization",
                text: "We adapt to evolving trends and algorithms to ensure ongoing performance"
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section iot-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Digital Marketing Solutions</h2>
            <p className="section-description">
              What makes our digital marketing services stand out from the rest
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" >
            {[
              {
                icon: "fas fa-eye",
                title: "Increased Visibility",
                text: " Improve rankings, reach, and online presence."
              },
              {
                icon: "fas fa-bullseye",
                title: "Targeted Reach",
                text: "Deliver messages to the right audience at the right time."
              },
              {
                icon: "fas fa-chart-bar",
                title: "Data-Driven Decisions",
                text: "Make strategic adjustments based on analytics."
              },
              {
                icon: "fas fa-thumbs-up",
                title: "Customized Strategies",
                text: "Marketing plans designed for your unique business goals.."
              },
              {
                icon: "fas fa-sitemap",
                title: "Multi-Channel Approach",
                text: " Maximize results with a 360° marketing strategy."
              },
              {
                icon: "fas fa-hands-helping",
                title: "Ongoing Support",
                text: " We continuously monitor, refine, and scale campaigns."
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx}>
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section mt-5 iot-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Boost Your Online Presence?</h2>
            <p>Let's create powerful digital marketing strategies that connect you with your target audience and drive business growth.</p>
            <a href="/contact" className="cta-button">Get a Free Digital Marketing Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DigitalMarketing;
